import { getTenantIdAuth0, isAdminAuth0 } from "../authUtils";
import getTenantIdFromURL from "./getTenantIdFromURL";
import { getTenantById } from "../api/tenantApi";


export const getTenantInfo = async () => {
  try {
    const isAdmin = await isAdminAuth0();

    const selectedTenant = getTenantIdFromURL();
    const tenantId = isAdmin ? selectedTenant : await getTenantIdAuth0();

    let response = await getTenantById(tenantId);

    const tenant = response?.data || {};
    const name = tenant?.name || '';
    const isAREnabled = tenant?.isAREnabled || false;
    const role = tenant?.role || '';
    const isPaid = tenant?.isPaid || false;
    const agingUpdatedUpTo = tenant?.agingUpdatedUpTo || 0;
    const counter = tenant?.counter || 0
    const maxCounterLimit = tenant?.maxCounterLimit || 0
    return { tenantId, name, isAREnabled, role, isPaid, agingUpdatedUpTo, counter, maxCounterLimit };
  } catch (error) {
    console.error('Error fetching tenant info:', error);
    return { name: '', isAREnabled: false };
  }
};
